import Button from '@carvana/ds-button';
import Link from '@carvana/ds-link';
import { useState } from 'react';
import Collapse from '@/common/Collapse';
import { useConfiguration } from '~/context/common/StaticContext';
import type { LinkData, SectionLink } from '~/contracts/common/Seo';
import {
  InternalLinkModTitle,
  GridWrapper,
  Wrapper
} from './InternalLinkModule.styles';

type OwnProps = {
  linksData?: SectionLink;
};

export default function InternalLinkMod({ linksData }: OwnProps) {
  const { shouldUseTitleCasing } = useConfiguration();
  const [isExpanded, setIsExpanded] = useState(false);

  if (!linksData) return null;

  const { links = [], title: sectionTitle = '' } = linksData;
  const showViewMoreButton = links.length > 9;

  function outputMappedLink({ text, link }: LinkData) {
    return (
      <Link
        data-adobe-id={null}
        data-analytics-id="SEO Links"
        data-testid="seo-link"
        key={link}
        href={`/cars${link}`}
        size="sm"
        className="w-fit no-underline t-label-sm"
      >
        {text}
      </Link>
    );
  }

  return links.length ? (
    <Wrapper>
      <div className="flex w-full flex-col items-center gap-2xl">
        <InternalLinkModTitle>{sectionTitle}</InternalLinkModTitle>
        <div className="w-full">
          <GridWrapper>{links.slice(0, 9).map(outputMappedLink)}</GridWrapper>
          <Collapse isCollapsed={!isExpanded} className="col-span-3 w-full">
            <GridWrapper className="mt-xl">
              {links.slice(9, links.length).map(outputMappedLink)}
            </GridWrapper>
          </Collapse>
        </div>
        {showViewMoreButton && (
          <Button
            className="w-full sm:w-auto"
            data-adobe-id={null}
            data-analytics-id="SEO Links"
            data-testid="seo-view-more"
            size="sm"
            variant="tertiary"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            {isExpanded
              ? shouldUseTitleCasing
                ? 'View Less'
                : 'View less'
              : shouldUseTitleCasing
              ? 'View More'
              : 'View more'}
          </Button>
        )}
      </div>
    </Wrapper>
  ) : null;
}
